'use strict';

exports.makeChain = function (left, right) {
    var args = [].slice.call(arguments, 0);
    if (args.length == 2 && !right || args.length == 1) {
        return left;
    }
    return function () {
        for (var i = args.length - 1; i >= 0; i--) {
            if (args[i] && typeof args[i] == 'function') {
                args[i].apply(this, arguments);
            }
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/@alicd/next/lib/_components/@alicd/next-util/lib/func.js
// module id = 102
// module chunks = 0